const DASHBOARD_API = {
    // Vouchertype wise sales
    VOUCHERTYPE_WISE_SALES_LIST: "api/dashboard/VoucherTypeWiseSales",
    MONTH_SALES_LIST: "api/dashboard/MonthSalesReport",
    BRANCH_WISE_SALES_LIST: "api/dashboard/BranchWiseSalesReport",
    TOP_FIVE_ITEM_SALES_LIST: "api/dashboard/TopItemSalesReport",
    YEAR_WISE_SALES_LIST: "api/dashboard/YearWiseSalesList",
};

export default DASHBOARD_API;